import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const TrailerCategories = () => {
  const navigate = useNavigate();

  const categories = [
    {
      id: 1,
      name: "Utility Trailers",
      icon: "Package",
      count: 0,
      description: "Perfect for moving, hauling, and general purpose use"
    },
    {
      id: 2,
      name: "Enclosed Trailers",
      icon: "Box",
      count: 0,
      description: "Weather-protected cargo transport for valuable items"
    },
    {
      id: 3,
      name: "Flatbed Trailers",
      icon: "Minus",
      count: 0,
      description: "Heavy equipment and oversized load transportation"
    },
    {
      id: 4,
      name: "Car Haulers",
      icon: "Car",
      count: 0,
      description: "Specialized trailers for vehicle transportation"
    },
    {
      id: 5,
      name: "Dump Trailers",
      icon: "Trash2",
      count: 0,
      description: "Construction and landscaping material hauling"
    },
    {
      id: 6,
      name: "Equipment Trailers",
      icon: "Wrench",
      count: 0,
      description: "Heavy-duty trailers for machinery and equipment"
    }
  ];

  const handleCategoryClick = (categoryName) => {
    navigate('/search-results', { 
      state: { 
        searchData: { 
          trailerType: categoryName?.toLowerCase()?.replace(' ', '-') 
        } 
      } 
    });
  };

  return (
    <section className="py-12 md:py-16 lg:py-20 bg-muted">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-3xl lg:text-4xl text-foreground mb-3 md:mb-4">
            Browse by Category
          </h2>
          <p className="font-body text-base md:text-lg text-muted-foreground max-w-2xl mx-auto">
            Find the right trailer type for your specific hauling needs
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {categories?.map((category) => (
            <button
              key={category?.id}
              onClick={() => handleCategoryClick(category?.name)}
              className="bg-card rounded-lg p-6 md:p-8 shadow-elevation-2 transition-smooth hover:shadow-elevation-3 hover:border-primary border-2 border-transparent text-left"
            >
              <div className="flex items-start space-x-4">
                <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Icon name={category?.icon} size={24} color="var(--color-primary)" strokeWidth={2} className="md:w-7 md:h-7" />
                </div>

                <div className="flex-1">
                  <div className="flex items-center justify-between mb-2">
                    <h3 className="font-heading font-semibold text-base md:text-lg text-foreground">
                      {category?.name}
                    </h3>
                    <span className="font-caption text-xs text-muted-foreground bg-muted px-2 py-1 rounded whitespace-nowrap">
                      {category?.count}+
                    </span>
                  </div>
                  <p className="font-body text-sm text-muted-foreground line-clamp-2">
                    {category?.description}
                  </p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrailerCategories;